export var rotateRect90deg = function (x, y, width, height) {
    return {
        x: x + width / 2 - height / 2,
        y: y + height / 2 - width / 2,
        width: height,
        height: width
    };
};
export var rotate_Rect_LTRB_90deg = function (l, t, r, b) {
    return {
        l: l + r / 2 - r / 2,
        t: t + b / 2 - b / 2,
        r: b,
        b: r
    };
};
